import 'modern-normalize/modern-normalize.css';
import "@/styles/main.scss";

import detectTouchDevice from "@/core/detectTouchDevice.js";
import processLinks from "@/core/processLinks.js";
import applyIcons from "@/core/applyIcons.js";
import applyWidgets from "@/core/applyWidgets.js";
import calcScrollbarWidth from "@/core/calcScrollbarWidth.js";

import onDomReady from "@/utils/onDomReady.js";

onDomReady(function () {
    detectTouchDevice();
    calcScrollbarWidth();
    processLinks();
    applyWidgets();
    applyIcons();    
});
